module.exports = __webpack_public_path__ + "img/glogo299.95f79b3d.png";